<template>
    <div class="">
        <div class="">
            <button  data-bs-toggle="modal" data-bs-target="#exampleModal" class="btn btn-primary position-absolute position-fixed shadow-lg" style="bottom: 75px; right: 10px; z-index: 1">
                <i class="bi-plus-circle"></i>
            </button>

            <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <form action="">
                                <div class="mt-3">
                                    <label class="form-label" for="name">Name</label>
                                    <input class="form-control" v-model="form.name" type="text" id="name" placeholder="User Name">
                                </div>
                                <div class="mt-3">
                                    <label class="form-label" for="email">Email</label>
                                    <input class="form-control" v-model="form.email" type="text" id="email" placeholder="User Email">
                                </div>
                                <div class="my-3">
                                    <button @click.prevent="onSubmit()" class="btn btn-outline-primary">Create New User</button>
                                </div>
                            </form>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="button" class="btn btn-primary">Save changes</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


    import {createUser, timestamp} from "../firebase";
    import {reactive} from 'vue'

    export default {
        name: "UserCreate",
        setup() {

            const form = reactive({ name: "", email: "", created_at: timestamp})

            const onSubmit = async () => {
                await createUser({...form})
                form.name = "";
                form.email = "";
            }

            return { form, onSubmit }

        }
    }
</script>

<style scoped>

</style>